module.exports = __webpack_public_path__ + "static/img/h2-6.c8f0a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h2-6.png
// module id = 3pUU
// module chunks = 1